import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getWebsiteSettingData } from '../../../Redux/action/MasterAction'
import { useFormik } from "formik";
import toast, { Toaster } from 'react-hot-toast';

import axios from 'axios';
import { FocusError } from 'focus-formik-error';
import * as Yup from "yup";
import './scss/common.css'
const host = process.env.REACT_APP_API_SERVER
const Footer = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getWebsiteSettingData());
    }, [])

    const {
        loadingWebsiteSettingDataListApi,
        WebsiteSettingDataListApiData,
        WebsiteSettingDataListApiError

    } = useSelector(state => state?.MasterReducer);

    let [initialValues, setInitialValues] = useState({

        email: "",

    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            email: Yup.string().required("Email is required.").matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, "Enter a valid E-mail"),

        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true)
            try {






                await axios.post(`${host}/api/web/newsletter`, values)
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success("Form Submitted Succesfully");

                            resetForm()
                        } else {

                            setSubmitting(false)

                            toast.error(response.data.msg);

                            resetForm()
                        }
                    })
                    .catch(function (error) {


                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                        resetForm()
                    })

            }
            catch (error) {


                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

                resetForm()
            }

        }
    })
    return (
        <footer className="footer-wrap" id="cont">

            {/* ================= Newsletter Section ================= */}


            {/* ================= Footer Links Section ================= */}
            <section className='footer-parent-sec '>
                <div className='container'>
                    <section className="newsletter-section py-5">
                        <div className="container">
                            <div className="newsletter-card">
                                <div className="row align-items-center">

                                    {/* Left Text */}
                                    <div className="col-lg-6 col-md-12 mb-3 mb-lg-0">
                                        <h4 className="text-white fw-bold mb-1">
                                            Subscribe to get latest updates
                                        </h4>
                                        <p className="text-light mb-0">
                                            Be the first to know about new features
                                        </p>
                                    </div>

                                    {/* Right Form */}
                                    <div className="col-lg-6 col-md-12">
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="newsletter-form d-flex">

                                                <input
                                                    type="text"
                                                    name="email"
                                                    placeholder="Enter your email"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.email}
                                                    className="newsletter-input"
                                                />

                                                <button
                                                    type="submit"
                                                    disabled={formik.isSubmitting}
                                                    className="newsletter-btn"
                                                >
                                                    Subscribe
                                                </button>
                                            </div>

                                            {formik.touched.email && formik.errors.email && (
                                                <div className="text-danger mt-2">
                                                    {formik.errors.email}
                                                </div>
                                            )}
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                    <div className='row'>


                        <div className='col-lg-3 col-md-6 mb-4 footer-logo'>
                            <img
                                src="/website/assets/img/logo.png"
                                alt="Logo"
                                style={{ maxHeight: 70 }}
                                className="mb-3"
                            />

                            <div className='d-flex gap-3 mt-3 text-white'>
                                <a href={WebsiteSettingDataListApiData?.instagram_link} target='_blank' >
                                    <i className="fa-brands fa-square-instagram"></i>
                                </a>
                                <a href={WebsiteSettingDataListApiData?.facebook_link} target='_blank'>
                                    <i className="fa-brands fa-facebook"></i>
                                </a>
                                <a href={WebsiteSettingDataListApiData?.linkedin_link} target='_blank'>
                                    <i className="fa-brands fa-linkedin"></i>
                                </a>
                                <a href={WebsiteSettingDataListApiData?.twitter_link} target='_blank'>
                                    <i className="fa-brands fa-square-x-twitter"></i>
                                </a>
                            </div>
                        </div>


                        {/* 2️⃣ Quick Links */}
                        <div className='col-lg-3 col-md-6 mb-4'>
                            <h5 className='text-white mb-3'>Quick Links</h5>
                            <ul className='list-unstyled'>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about-us">About Us</Link></li>
                                <li><Link to="/find-tutor">Find a Tutor</Link></li>
                                <li><Link to="/become-tutor">Become a Tutor</Link></li>
                                <li><Link to="/blog">Blog</Link></li>
                                {/* <li><Link to="/contact">Contact</Link></li> */}
                            </ul>
                        </div>


                        {/* 3️⃣ Policies */}
                        <div className='col-lg-3 col-md-6 mb-4'>
                            <h5 className='text-white mb-3'>Information</h5>
                            <ul className='list-unstyled'>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                                <li>
                                    <a
                                        href="https://docs.google.com/forms/d/17wnWQkio6nE9hiSQJXwEP82eh6D6s9jmlpi3VXgLxyY/viewform"
                                        target="_blank"
                                    >
                                        Feedback
                                    </a>
                                </li>
                            </ul>
                        </div>


                        {/* 4️⃣ Contact Info */}
                        <div className='col-lg-3 col-md-6 mb-4'>
                            <h5 className='text-white mb-3'>Contact Us</h5>
                            <p>
                                <strong>Email:</strong><br />
                                <a href={`mailto:${WebsiteSettingDataListApiData?.email}`}>
                                    {WebsiteSettingDataListApiData?.email}
                                </a>
                            </p>
                            <p>
                                <strong>Contact:</strong><br />
                                <a href={`tel:${WebsiteSettingDataListApiData?.mobile}`}>
                                    {WebsiteSettingDataListApiData?.mobile}
                                </a>
                            </p>
                        </div>

                    </div>


                </div>
                <div className='container text-center py-3'>
                    <p className="text-white mb-0">
                        © SEEK2LRN All Rights Reserved.
                    </p>
                </div>
            </section>


            {/* ================= Bottom Strip ================= */}
            {/* <section className='bottom-st-section'>
    <div className='container text-center py-3'>
      <p className="text-white mb-0">
        © SEEK2LRN All Rights Reserved.
      </p>
    </div>
  </section> */}

        </footer>


    )
}

export default Footer